import {
  FETCH_EAT_RESTAURANTS,
  FETCH_EAT_RESTAURANTS_SUCCESS,
  FETCH_EAT_RESTAURANTS_FAILED,
  UPDATE_EAT_RESTAURANT,
  UPDATE_EAT_RESTAURANT_SUCCESS,
  UPDATE_EAT_RESTAURANT_FAILED,
  FETCH_EAT_MENU,
  FETCH_EAT_MENU_SUCCESS,
  FETCH_EAT_MENU_FAILED,
  UPDATE_EAT_MENU,
  UPDATE_EAT_MENU_SUCCESS,
  UPDATE_EAT_MENU_FAILED,
  FETCH_EAT_SETTINGS,
  FETCH_EAT_SETTINGS_SUCCESS,
  FETCH_EAT_SETTINGS_FAILED,
  FETCH_EAT_ORDERS,
  FETCH_EAT_ORDERS_SUCCESS,
  FETCH_EAT_ORDERS_FAILED,
  FETCH_EAT_COURIERS,
  FETCH_EAT_COURIERS_SUCCESS,
  FETCH_EAT_COURIERS_FAILED,
  FETCH_EAT_PROMOS,
  FETCH_EAT_PROMOS_SUCCESS,
  FETCH_EAT_PROMOS_FAILED,
  EDIT_EAT_PROMOS,
  CREATE_EAT_ORDER,
  CREATE_EAT_ORDER_SUCCESS,
  CREATE_EAT_ORDER_FAILED,
  UPDATE_EAT_ORDER,
  UPDATE_EAT_ORDER_SUCCESS,
  UPDATE_EAT_ORDER_FAILED,
  UPDATE_EAT_COURIER,
  UPDATE_EAT_COURIER_SUCCESS,
  UPDATE_EAT_COURIER_FAILED,
  SET_EAT_CART,
  ADD_EAT_CART_ITEM,
  UPDATE_EAT_CART_ITEM_QTY,
  REMOVE_EAT_CART_ITEM,
  CLEAR_EAT_CART,
  CLEAR_EAT_MESSAGES
} from "../store/types";

const getRestaurantKey = (restaurant = {}) => restaurant.id || restaurant.restaurantId || restaurant.uid || restaurant.name || '';

const INITIAL_STATE = {
  restaurants: [],
  orders: [],
  couriers: [],
  promos: [],
  settings: {},
  menus: {},
  cart: {
    restaurant: null,
    items: []
  },
  activeOrder: null,
  loading: false,
  error: null,
  message: null
};

const applyNestedPatch = (source = {}, patch = {}) => Object.keys(patch || {}).reduce((next, path) => {
  if (!path.includes('/')) return { ...next, [path]: patch[path] };
  const parts = path.split('/').filter(Boolean);
  const updated = { ...next };
  let cursor = updated;
  parts.forEach((part, index) => {
    if (index === parts.length - 1) {
      cursor[part] = patch[path];
      return;
    }
    cursor[part] = { ...(cursor[part] || {}) };
    cursor = cursor[part];
  });
  return updated;
}, { ...source });

export const eatreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_EAT_RESTAURANTS:
    case UPDATE_EAT_RESTAURANT:
    case FETCH_EAT_MENU:
    case UPDATE_EAT_MENU:
    case FETCH_EAT_SETTINGS:
    case FETCH_EAT_ORDERS:
    case FETCH_EAT_COURIERS:
    case FETCH_EAT_PROMOS:
    case CREATE_EAT_ORDER:
    case UPDATE_EAT_ORDER:
    case UPDATE_EAT_COURIER:
      return { ...state, loading: true, error: null, message: null };

    case FETCH_EAT_RESTAURANTS_SUCCESS:
      return { ...state, loading: false, restaurants: action.payload, error: null };

    case UPDATE_EAT_RESTAURANT_SUCCESS: {
      const existingRestaurant = state.restaurants.some(restaurant => restaurant.id === action.payload.id);
      return {
        ...state,
        loading: false,
        restaurants: existingRestaurant ? state.restaurants.map(restaurant => restaurant.id === action.payload.id ? { ...restaurant, ...action.payload } : restaurant) : [action.payload, ...state.restaurants],
        message: 'Eat restaurant updated',
        error: null
      };
    }

    case FETCH_EAT_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        menus: {
          ...state.menus,
          [action.payload.restaurantId]: action.payload.menu
        },
        error: null
      };

    case UPDATE_EAT_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        menus: {
          ...state.menus,
          [action.payload.restaurantId]: applyNestedPatch(state.menus[action.payload.restaurantId] || {}, action.payload.patch)
        },
        message: 'Eat menu updated',
        error: null
      };

    case FETCH_EAT_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload || {}, error: null };

    case FETCH_EAT_ORDERS_SUCCESS:
      return { ...state, loading: false, orders: action.payload, error: null };

    case FETCH_EAT_COURIERS_SUCCESS:
      return { ...state, loading: false, couriers: action.payload, error: null };

    case FETCH_EAT_PROMOS_SUCCESS:
      return { ...state, loading: false, promos: action.payload, error: null };

    case CREATE_EAT_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        activeOrder: action.payload,
        orders: [action.payload, ...state.orders.filter(order => order.id !== action.payload.id)],
        message: 'Eat order created',
        error: null
      };

    case UPDATE_EAT_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        activeOrder: action.payload,
        orders: state.orders.map(order => order.id === action.payload.id ? { ...order, ...action.payload } : order),
        message: 'Eat order updated',
        error: null
      };

    case UPDATE_EAT_COURIER_SUCCESS: {
      const existingCourier = state.couriers.some(courier => courier.id === action.payload.id);
      return {
        ...state,
        loading: false,
        couriers: existingCourier ? state.couriers.map(courier => courier.id === action.payload.id ? { ...courier, ...action.payload } : courier) : [action.payload, ...state.couriers],
        message: 'Eat courier updated',
        error: null
      };
    }

    case EDIT_EAT_PROMOS:
      return { ...state, loading: false, message: 'Eat promo updated', error: null };

    case SET_EAT_CART:
      return {
        ...state,
        cart: {
          restaurant: action.payload.restaurant || null,
          items: Array.isArray(action.payload.items) ? action.payload.items : []
        }
      };

    case ADD_EAT_CART_ITEM: {
      const restaurant = action.payload.restaurant || {};
      const item = action.payload.item || {};
      const restaurantKey = getRestaurantKey(restaurant);
      const currentRestaurantKey = getRestaurantKey(state.cart.restaurant || {});
      const currentItems = restaurantKey && restaurantKey === currentRestaurantKey ? state.cart.items : [];
      const itemKey = item.cartKey || item.id;
      const existingItem = currentItems.find(cartItem => (cartItem.cartKey || cartItem.id) === itemKey);
      const items = existingItem ?
        currentItems.map(cartItem => (cartItem.cartKey || cartItem.id) === itemKey ? { ...cartItem, qty: Number(cartItem.qty || 1) + 1 } : cartItem) :
        [...currentItems, { ...item, qty: 1 }];
      return { ...state, cart: { restaurant, items } };
    }

    case UPDATE_EAT_CART_ITEM_QTY: {
      const itemKey = action.payload.cartKey;
      const qty = Number(action.payload.qty || 0);
      const items = state.cart.items
        .map(cartItem => (cartItem.cartKey || cartItem.id) === itemKey ? { ...cartItem, qty } : cartItem)
        .filter(cartItem => Number(cartItem.qty || 0) > 0);
      return { ...state, cart: { ...state.cart, items } };
    }

    case REMOVE_EAT_CART_ITEM: {
      const itemKey = action.payload.cartKey;
      const items = state.cart.items.filter(cartItem => (cartItem.cartKey || cartItem.id) !== itemKey);
      return { ...state, cart: { ...state.cart, items } };
    }

    case CLEAR_EAT_CART:
      return { ...state, cart: { restaurant: null, items: [] } };

    case FETCH_EAT_RESTAURANTS_FAILED:
      return { ...state, loading: false, restaurants: [], error: action.payload };

    case FETCH_EAT_MENU_FAILED:
      return { ...state, loading: false, error: action.payload };

    case FETCH_EAT_SETTINGS_FAILED:
      return { ...state, loading: false, error: action.payload };

    case FETCH_EAT_ORDERS_FAILED:
      return { ...state, loading: false, orders: [], error: action.payload };

    case FETCH_EAT_COURIERS_FAILED:
      return { ...state, loading: false, couriers: [], error: action.payload };

    case FETCH_EAT_PROMOS_FAILED:
      return { ...state, loading: false, promos: [], error: action.payload };

    case CREATE_EAT_ORDER_FAILED:
    case UPDATE_EAT_ORDER_FAILED:
    case UPDATE_EAT_RESTAURANT_FAILED:
    case UPDATE_EAT_MENU_FAILED:
    case UPDATE_EAT_COURIER_FAILED:
      return { ...state, loading: false, error: action.payload };

    case CLEAR_EAT_MESSAGES:
      return { ...state, error: null, message: null };

    default:
      return state;
  }
};
